module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "data": _vm.subscriberInfo,
      "label-width": "80px",
      "size": "mini",
      "label-position": "left",
      "disabled": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.nickname),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "nickname", $$v)
      },
      expression: "subscriberInfo.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.phoneNo),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "phoneNo", $$v)
      },
      expression: "subscriberInfo.phoneNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.subscriberInfo.gender),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "gender", $$v)
      },
      expression: "subscriberInfo.gender"
    }
  }, _vm._l((_vm.genderOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.birthday),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "birthday", $$v)
      },
      expression: "subscriberInfo.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.province),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "province", $$v)
      },
      expression: "subscriberInfo.province"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "市"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.city),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "city", $$v)
      },
      expression: "subscriberInfo.city"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.county),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "county", $$v)
      },
      expression: "subscriberInfo.county"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "address", $$v)
      },
      expression: "subscriberInfo.address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.createTime),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "createTime", $$v)
      },
      expression: "subscriberInfo.createTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分享码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.subscriberInfo.shareCode),
      callback: function($$v) {
        _vm.$set(_vm.subscriberInfo, "shareCode", $$v)
      },
      expression: "subscriberInfo.shareCode"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-c50a0400","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/subscriber/components/subscriberInfo.vue
// module id = 1742
// module chunks = 0